var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form__group" },
    [
      _c("TreeSelect", {
        class: {
          form__control: true,
          "form__control--invalid": _vm.errors.first(this.name),
        },
        attrs: {
          options: _vm.options,
          searchable: true,
          "always-open": false,
          "load-options": _vm.loadOptions,
          flattenSearchResults: true,
          placeholder: "Select...",
          normalizer: _vm.normalizer,
          valueFormat: _vm.valueFormat,
        },
        model: {
          value: _vm.selected,
          callback: function ($$v) {
            _vm.selected = $$v
          },
          expression: "selected",
        },
      }),
      _vm._v(" "),
      _c("label", { staticClass: "form__label" }, [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form__validation",
          attrs: { slot: "validation" },
          slot: "validation",
        },
        [_vm._v(_vm._s(_vm.errors.first(this.name)))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }